import Repository from '../Repository'

class MenuRepository {
  constructor() {
    this.resource = '/menus'
  }

  async getMenus() {
    return Repository.get(`${this.resource}`)
  }

  async getMenusByService(serviceId) {
    return Repository.get(`${this.resource}/service/${serviceId}`)
  }

  async getMenu(id) {
    return Repository.get(`${this.resource}/${id}`)
  }

  async createMenu(data) {
    return Repository.post(`${this.resource}`, data)
  }

  async updateMenu(id, data) {
    return Repository.put(`${this.resource}/${id}`, data)
  }

  async deleteMenu(id) {
    return Repository.delete(`${this.resource}/${id}`)
  }

  async getMenuColors() {
    return Repository.get('/menu-colors')
  }
}

export default new MenuRepository() 